<script setup>

import { onMounted, ref, watch } from 'vue'
import store from '@/store'
import Dialog from 'primevue/dialog'

const firstConnexion = ref(null)

watch(() => store.state.auth.status.loggedIn, (loggedIn) => {
    firstConnexion.value = false

    if(loggedIn && store.state.auth.user.first_connexion == true) {
        firstConnexion.value = true
    }
})

const close = () => {
    firstConnexion.value = false
}

onMounted(() => {
    if(store.state.auth.status.loggedIn && store.state.auth.user.firstConnexion === true) {
        firstConnexion.value = true
    }
})

</script>

<template>

<div>
    <Dialog
        v-model:visible="firstConnexion"
        modal
        class="flex justify-center items-center"
        :showHeader="false"
        :dismissableMask="true"
        :baseZIndex="1500"
        contentClass="relative p-0 rounded-lg bg-white dark:bg-gray-900"
    >
        <header class="bg-orange-300 p-2">
            <div class="text-right">
                <div @click="close()" class="cursor-pointer">Fermer</div>
            </div>
        </header>

        <div class="m-0 px-16 py-10 relative bg-white dark:bg-gray-900 border border-orange-300">
            <div class="m-8 p-2 text-center">
                <p>Bienvenue sur l'application Lune et Pistache : Prise de rendez-vous.</p>
                <p class="mt-4">Vous pouvez créer un premier agenda gratuitement qui sera disponible une semaine.</p>
                <p class="mt-4">Vous pouvez configurer votre compte et vos agendas dans l'entête en haut à droite.</p>
                <p class="mt-12">
                    <button @click="close()" class="btn cursor-pointer">Fermer</button>
                </p>
            </div>
        </div>
    </Dialog>
</div>

</template>
